import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const cards = [
  {
    titleKey: 'type_1_title',
    subKey: 'type_1_sub',
    descKey: 'type_1_desc',
    img: 'https://readdy.ai/api/search-image?query=Close-up%20architectural%20detail%20of%20standing%20seam%20metal%20roof%20with%20vertical%20ribs%2C%20dark%20slate%20blue%20panels%2C%20precise%20mechanical%20seams%2C%20premium%20residential%20roofing%2C%20warm%20afternoon%20light%20highlighting%20rib%20edges%2C%20Quebec%20premium%20construction%2C%20editorial%20photography%2C%20clean%20sharp%20lines%2C%20no%20text%20visible&width=600&height=400&seq=tole-standing1&orientation=landscape',
    alt: 'Toiture joint debout standing seam acier ardoise Lévis',
  },
  {
    titleKey: 'type_2_title',
    subKey: 'type_2_sub',
    descKey: 'type_2_desc',
    img: 'https://readdy.ai/api/search-image?query=Close-up%20of%20hidden%20fastener%20snap-lock%20metal%20roofing%20panel%2C%20dark%20forest%20green%20color%2C%20seamless%20interlocking%20panels%2C%20professional%20roofing%20detail%20shot%2C%20warm%20golden%20sunlight%2C%20premium%20Quebec%20residential%20roofing%2C%20clean%20modern%20architecture%2C%20editorial%20photography%2C%20no%20text%20visible&width=600&height=400&seq=tole-snaplock1&orientation=landscape',
    alt: 'Tôle à agrafes cachées snap lock vert forêt Lévis',
  },
  {
    titleKey: 'type_3_title',
    subKey: 'type_3_sub',
    descKey: 'type_3_desc',
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20aged%20copper%20roofing%20on%20Quebec%20heritage%20building%2C%20green%20patina%20surface%2C%20traditional%20artisanal%20sheet%20metal%20work%2C%20ornate%20dormer%20and%20valley%20flashing%20details%2C%20warm%20golden%20hour%20light%2C%20architectural%20heritage%20photography%2C%20no%20text%20visible%2C%20editorial%20magazine%20quality&width=600&height=400&seq=tole-cuivre1&orientation=landscape',
    alt: 'Ferblanterie traditionnelle cuivre patiné maison patrimoniale Lévis',
  },
];

export default function TypesTole() {
  const { t } = useTranslation('tole');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="types-tole" className="bg-soft-gray py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('types_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-6">
          {cards.map((card, idx) => (
            <div
              key={idx}
              className={`bg-white rounded-xl overflow-hidden transition-all duration-700 hover:-translate-y-1 hover:shadow-sm ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 150 + 200}ms` }}
            >
              <div className="h-52 md:h-56 overflow-hidden">
                <img
                  src={card.img}
                  alt={`${card.alt} — couvreur certifié RBQ à Lévis`}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width="600"
                  height="400"
                />
              </div>
              <div className="p-5 md:p-6">
                <span className="inline-block text-copper text-xs font-semibold uppercase tracking-wider bg-copper/10 px-2 py-1 rounded-full mb-2">
                  {t(card.subKey)}
                </span>
                <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base mb-2">
                  {t(card.titleKey)}
                </h3>
                <p className="text-slate-primary/60 text-xs md:text-sm leading-relaxed">
                  {t(card.descKey)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}